import React, { useState } from 'react'
import { Trans } from '@lingui/macro'
import {
  TopicElementModelAsEditor,
  TopicModelAsEditor,
  TopicModelAsMember
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { EditElementWrapper } from '../EditElementWrapper'
import { ButtonPrimary } from 'front-end/src/components'
import { useTopicForEditQuery } from '../../../topic-edit-page/TopicEditPage'
import {
  usePatchEmbedLinkElementMutation,
  useIsIframeEnabledQuery
} from './EditEmbedLinkElement.codegen'
import { EmbeddedFileElement } from '../../topic-elements/embedded-file-element/EmbeddedFileElement'

const EditEmbedLinkElement = (props: {
  isMultiPage?: boolean
  element: TopicElementModelAsEditor
  topic: TopicModelAsMember | TopicModelAsEditor
}) => {
  const { element } = props
  const embedUrl = element.data?.embedUrl as string | null

  const { refetch: refetchTopic } = useTopicForEditQuery()

  const [editing, setEditing] = useState(!embedUrl)

  const [link, setLink] = useState(embedUrl || '')
  const [setLinkElementUrl, { loading }] = usePatchEmbedLinkElementMutation()
  const { data } = useIsIframeEnabledQuery({
    fetchPolicy: 'cache-first'
  })

  const setURL = async () => {
    const embedUrl = link.match(/src\s*=\s*"(.+?)"/)

    await setLinkElementUrl({
      variables: {
        topicId: props.topic.id,
        elementId: element.id,
        embedLink: embedUrl ? embedUrl[1] : link
      }
    })

    setEditing(false)
    refetchTopic()
  }

  return (
    <EditElementWrapper {...props}>
      {!editing ? (
        <EmbeddedFileElement
          {...element.data}
          activateEditing={
            data && data.organisation?.embed_domains?.enabled
              ? () => setEditing(true)
              : false
          }
        ></EmbeddedFileElement>
      ) : (
        <div className="link-edit">
          <label className="link-label" htmlFor="link-input">
            <Trans>Paste a source URL or an embed code</Trans>
          </label>
          <div>
            <textarea
              className="form-textAreaInput"
              style={{
                backgroundColor: 'white',
                resize: 'none',
                marginBottom: '20px',
                borderColor: '#b1bfc5'
              }}
              placeholder="https:// or <iframe...>"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />

            <ButtonPrimary
              disabled={!link}
              isLoading={loading}
              onClick={setURL}
            >
              <Trans>Save</Trans>
            </ButtonPrimary>
          </div>
        </div>
      )}
    </EditElementWrapper>
  )
}

export default EditEmbedLinkElement
